var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized } from '@lit/localize';
import { CommonMessages } from '../../localization/helpers.js';
let RadioCards = class RadioCards extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    handleCardClick(optionId) {
        this.value = optionId;
        this.dispatchEvent(new CustomEvent("radio-change", { detail: this.value }));
    }
    renderCard(option) {
        const isSelected = this.value === option.id;
        return html `
            <basic-card
                class="radio-card ${isSelected ? "selected" : ""}"
                align="center"
                aria-checked="${isSelected}"
                tabindex="0"
                @click=${() => this.handleCardClick(option.id)}
            >
                <div class="content">
                    ${option.icon
            ? html `<img src="${option.icon}" alt="${option.label} icon" class="icon" />`
            : ""}
                    <h3 class="label">${option.label}</h3>
                </div>
            </basic-card>
        `;
    }
    render() {
        if (!this.options || this.options.length === 0) {
            return html `<p>${CommonMessages.noData()}</p>`;
        }
        return html `
            <div class="radio-cards" role="radiogroup">
                ${this.options.map((option) => this.renderCard(option))}
            </div>
        `;
    }
};
RadioCards.styles = css `
        :host {
            display: block;
        }
        .radio-cards {
            display: flex;
            gap: 1rem;
            flex-wrap: wrap;
            width: 100%;
        }
        .radio-card {
            flex: 1 1 calc(33.333% - 1rem); /* Ajuste la largeur à 3 cartes par ligne */
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid #ccc;
            padding: 1rem;
            box-sizing: border-box;
        }
        .radio-card.selected {
            border-color: var(--primary-color, #0078d4);
            background-color: var(--selected-bg, #e6f7ff);
        }
        .radio-card:hover {
            border-color: var(--hover-border-color, #0078d4);
        }
        .icon {
            width: 64px;
            height: 64px;
            margin-top: 10px;
        }
        .label {
            font-size: 1rem;
            font-weight: 500;
        }
        h3 {
            margin: 10 0;
        }
    `;
__decorate([
    property({ type: String })
], RadioCards.prototype, "value", void 0);
__decorate([
    property({ type: Array })
], RadioCards.prototype, "options", void 0);
RadioCards = __decorate([
    localized(),
    customElement("radio-cards")
], RadioCards);
export { RadioCards };
//# sourceMappingURL=RadioCards.js.map